import { ReactNode, createContext, useContext } from "react";
import { useComplexState } from "use-complex-state";
import { LocationsReducer } from "../reducers/LocationReducer";

const LocationsContext = createContext({
	state: LocationsReducer.getInitialState(),
	actions: LocationsReducer.actions,
});
export const useLocationsContext = () => useContext(LocationsContext);

export const LocationProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: LocationsReducer.getInitialState(),
		reducers: LocationsReducer.caseReducers,
	});
	return (
		<LocationsContext.Provider value={{ state, actions }}>
			{children}
		</LocationsContext.Provider>
	);
};
